import { Actions, Data, State } from "../types";
import { getEmptyQuickscanState } from "../context/QuickscanDataContext";

const initialQuickscanDataState: State.Quickscan = getEmptyQuickscanState();

const quickscan = (state = initialQuickscanDataState, action: Actions.QuickscanDataActions): State.Quickscan => {
    switch (action.type) {
        case Actions.QuickscanDataTypes.SET_QUICKSCAN_DATA:
            return {
                ...state,
                ...action.payload,
            };
        case Actions.QuickscanDataTypes.SET_QUICKSCAN_STEP:
            return {
                ...state,
                currentStep: action.payload.step,
            };
        case Actions.QuickscanDataTypes.FINISH_QUICKSCAN:
            return {
                ...state,
                finished: action.payload.finished,
                error: action.payload.error,
            };
        case Actions.QuickscanDataTypes.VALIDATE_QUICKSCAN_STEP:
            let visited = [...state.visited];
            visited[action.payload.step] = true;
            return {
                ...state,
                validation: validateStep(action.payload.step, state.quickscan, state.validation),
                visited: visited
            };
        default:
            return state;
    }
};

const dataValidation = (quickscan: Data.Quickscan): Data.Validation => {

    return {
        fields: {
            organisation: validateText(quickscan.organisation),
            address: validateText(quickscan.address),
            zipcode: validateText(quickscan.zipcode),
            city: validateText(quickscan.city),
            firstName: validateText(quickscan.firstName),
            lastName: validateText(quickscan.lastName),
            position: validateText(quickscan.position),
            otherInfo: validateText(quickscan.otherInfo),
            phoneNumber: validateText(quickscan.phoneNumber),
            fte: validateAmount(quickscan.fte),
            previousRevenue: validateAmount(quickscan.previousRevenue),
            currentRevenue: validateAmount(quickscan.currentRevenue),
            activities: validateText(quickscan.activities),
            innovation: validateText(quickscan.innovation),
            ip: validateText(quickscan.ip),
            amount: validateAmount(quickscan.amount),
            equipment: validateText(quickscan.equipment),
            alternativeFunding: validateText(quickscan.alternativeFunding),
            otherFinancing: validateText(quickscan.otherFinancing),
            privacy: validateCheck(quickscan.privacy)
        },
        steps: [
            validateText(quickscan.organisation) && validateText(quickscan.address) && validateText(quickscan.zipcode) && validateText(quickscan.city) && validateText(quickscan.firstName) && validateText(quickscan.lastName)  && validateText(quickscan.position) && validateText(quickscan.otherInfo) && validateText(quickscan.phoneNumber),
            validateAmount(quickscan.fte) && validateAmount(quickscan.previousRevenue) && validateAmount(quickscan.currentRevenue) && validateText(quickscan.activities) && validateText(quickscan.innovation) && validateText(quickscan.ip),
            validateAmount(quickscan.amount) && validateText(quickscan.equipment) && validateText(quickscan.alternativeFunding) && validateText(quickscan.otherFinancing),
            validateCheck(quickscan.privacy)
        ]
    };

}

const validateStep = (step: number, quickscan: Data.Quickscan, validation: Data.Validation): Data.Validation => {

    let newValidation = {...validation};

    switch (step) {
        case 0 :
            newValidation.steps[0] = validateText(quickscan.organisation) && validateText(quickscan.address) && validateText(quickscan.zipcode) && validateText(quickscan.city) && validateText(quickscan.firstName) && validateText(quickscan.lastName) && validateText(quickscan.otherInfo) && validateText(quickscan.phoneNumber);
            newValidation.fields.organisation = validateText(quickscan.organisation);
            newValidation.fields.address= validateText(quickscan.address);
            newValidation.fields.zipcode= validateText(quickscan.zipcode);
            newValidation.fields.city= validateText(quickscan.city);
            newValidation.fields.firstName = validateText(quickscan.firstName);
            newValidation.fields.lastName = validateText(quickscan.lastName);
            newValidation.fields.position = validateText(quickscan.position);
            newValidation.fields.otherInfo = validateText(quickscan.otherInfo);
            newValidation.fields.phoneNumber = validateText(quickscan.phoneNumber);
            break;
        case 1 :
            newValidation.steps[1] = validateAmount(quickscan.fte) && validateAmount(quickscan.previousRevenue) && validateAmount(quickscan.currentRevenue) && validateText(quickscan.activities) && validateText(quickscan.innovation) && validateText(quickscan.ip);
            newValidation.fields.fte = validateAmount(quickscan.fte);
            newValidation.fields.previousRevenue = validateAmount(quickscan.previousRevenue);
            newValidation.fields.currentRevenue = validateAmount(quickscan.currentRevenue);
            newValidation.fields.activities = validateText(quickscan.activities);
            newValidation.fields.innovation = validateText(quickscan.innovation);
            newValidation.fields.ip = validateText(quickscan.ip);
            break;

        case 2 :
            newValidation.steps[2] = validateAmount(quickscan.amount) && validateText(quickscan.equipment) && validateText(quickscan.alternativeFunding) && validateText(quickscan.otherFinancing);
            newValidation.fields.amount = validateAmount(quickscan.amount);
            newValidation.fields.equipment = validateText(quickscan.equipment);
            newValidation.fields.alternativeFunding = validateText(quickscan.alternativeFunding);
            newValidation.fields.otherFinancing = validateText(quickscan.otherFinancing);
            break;

        case 3 :
            newValidation.steps[3] = validateCheck(quickscan.privacy);
            newValidation.fields.privacy = validateCheck(quickscan.privacy);
            break;
    }

    return newValidation;
}


export const validateAmount = (value: number) => {
    if (value === 0) {
        return false;
    }

    return true;
}

export const validateCheck = (value: boolean) => {
    return value;
}

export const validateText = (value: string) => {
    if (value.trim() === '') {
        return false;
    }

    return true;
}

export { initialQuickscanDataState, quickscan };
